import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import { HeadingOne } from 'Common/Custom/HeadingOne'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import RoomCheckInTable from './Components/RoomCheckInTable'

const RoomCheckInList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Check In List</HeadingOne>
                    <div className='d-flex gap-2 flex-wrap mt-sm-0 mt-2'>
                        <AddItemBtn url="create-room-check-in" title="Direct Check In" />
                    </div>
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <RoomCheckInTable />
            </div>
        </PageBody>
    )
}

export default RoomCheckInList
